export const ADD_EDIT_DELIVERY_GROUP_LOADING = 'ADD_EDIT_DELIVERY_GROUP_LOADING'
export const ADD_EDIT_DELIVERY_GROUP_ERROR = 'ADD_EDIT_DELIVERY_GROUP_ERROR'
export const ADD_EDIT_DELIVERY_GROUP_SUCCESS = 'ADD_EDIT_DELIVERY_GROUP_SUCCESS'
export const SET_GROUPS = 'SET_GROUPS'
export const DELETE_DELIVERY_GROUP_LOADING = 'DELETE_DELIVERY_GROUP_LOADING'
export const DELETE_DELIVERY_GROUP_ERROR = 'DELETE_DELIVERY_GROUP_ERROR'
export const DELETE_DELIVERY_GROUP_SUCCESS = 'DELETE_DELIVERY_GROUP_SUCCESS'